import { combineReducers } from "@reduxjs/toolkit";

/**
 * slices
 */
import { shoppingCartSlice } from "./shoppingCart";
import { searchFormSlice } from "./searchForm";
import { searchQuerySlice } from "./searchQuery";
import { filtersSlice } from "./filters";
import { sortSlice } from "./sort";
import { selectedItinerarySlice } from "./selectedItinerary";
import { contactInformationSlice } from "./contactInformation";
import { travelerInformationSlice } from "./travelerInformation";
import { additionalProductsSlice } from "./additionalProducts";
import { checkoutStepsSlice } from "./checkoutSteps";
import { transitionSlice } from "./transition/transition.slice";
import { languageSlice } from "./language";

/**
 * services
 */
import { translationsApi } from "./services/translations";
import { configApi } from "./services/config";
import { airportSearchApi } from "./services/airportSearch";
import { airlinesSearchApi } from "./services/airlinesSearch";
import { flightSearchApi } from "./services/flightSearch";
import { revalidateApi } from "./services/revalidate";
import { bookingApi } from "./services/booking";
import { confirmApi } from "./services/confirm";
import { countryListApi } from "./services/countryList";
import { iataLookupApi } from "./services/iataLookup";
import { cancelPaymentApi } from "./services/cancelPayment";

const rootReducer = combineReducers({
  searchForm: searchFormSlice.reducer,
  searchQuery: searchQuerySlice.reducer,
  filters: filtersSlice.reducer,
  sort: sortSlice.reducer,
  selectedItinerary: selectedItinerarySlice.reducer,
  contactInformation: contactInformationSlice.reducer,
  travelerInformation: travelerInformationSlice.reducer,
  additionalProducts: additionalProductsSlice.reducer,
  checkoutSteps: checkoutStepsSlice.reducer,
  transition: transitionSlice.reducer,
  language: languageSlice.reducer,
  shoppingCart: shoppingCartSlice.reducer,
  [configApi.reducerPath]: configApi.reducer,
  [translationsApi.reducerPath]: translationsApi.reducer,
  [airportSearchApi.reducerPath]: airportSearchApi.reducer,
  [iataLookupApi.reducerPath]: iataLookupApi.reducer,
  [airlinesSearchApi.reducerPath]: airlinesSearchApi.reducer,
  [flightSearchApi.reducerPath]: flightSearchApi.reducer,
  [countryListApi.reducerPath]: countryListApi.reducer,
  [revalidateApi.reducerPath]: revalidateApi.reducer,
  [bookingApi.reducerPath]: bookingApi.reducer,
  [cancelPaymentApi.reducerPath]: cancelPaymentApi.reducer,
  [confirmApi.reducerPath]: confirmApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
